import { Helmet } from 'react-helmet-async';

// Seo — sets page title, description, canonical URL, Open Graph + Twitter
// social tags, and JSON-LD structured data. Used on every page.
const SITE_NAME = 'Devlayar';
const SITE_URL = 'https://www.devlayar.com';
const OG_IMAGE = `${SITE_URL}/web-app-manifest-512x512.png`; // your logo for link previews

export default function Seo({ title, description, path }) {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Free Online PDF & Image Tools`;
  const url = `${SITE_URL}${path || ''}`;
  const desc = description ||
    'Free online tools for PDF and images. Merge, split, compress PDFs. Resize, compress, remove backgrounds. QR codes, resume builder and more. No signup required.';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebApplication',
    name: title ? `${title} — ${SITE_NAME}` : SITE_NAME,
    url,
    applicationCategory: 'UtilitiesApplication',
    operatingSystem: 'Web',
    offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD' },
    description: desc,
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* Open Graph (WhatsApp, Facebook, LinkedIn link previews) */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:image" content={OG_IMAGE} />

      {/* Twitter card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={OG_IMAGE} />

      <meta name="robots" content="index, follow" />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
